import ImpressionDivWrapper from '@/components/Common/ImpressionDivWrapper';
import NolPointCard from './NolPointCard';
import { NolPromotionStoreCtx } from '@/stores/NolPromotionStore';
import useIsomorphicEffect from '@/utils/useIsomorphicEffect';
import { observer } from 'mobx-react-lite';
import React, { FC, useContext, useRef } from 'react';

import styles from '../benefits.module.scss';
import LoungeEventCard from './LoungeEventCard';

const NolCardBaseBenefits: FC = () => {
  const store = useContext(NolPromotionStoreCtx);
  const cardRef3 = useRef<HTMLDivElement>(null);
  const cardRef4 = useRef<HTMLDivElement>(null);
  useIsomorphicEffect(() => {
    store.anchorTab2Ref = cardRef3;
    store.anchorTab3Ref = cardRef4;
  }, []);

  return (
    <div className={styles.container} ref={cardRef3}>
      <div className={styles.title}>
        쓸수록 적립 받는 <br />
        NOL 카드 혜택
      </div>
      {/* card */}
      <div className={styles.cardsContainer}>
        <div className={styles.cardItemWrapper} ref={cardRef3}>
          <ImpressionDivWrapper
            className={styles.impressionWrapper}
            logData={{
              pageName: store.pageName,
              objectContainer: 'NOL에서 놀때는 NOL 카드',
              motherPageVersion: store.version,
              motherPageSectionType: '혜택',
              motherPageSectionName: 'NOL 포인트 10% 적립',
            }}
          >
            <NolPointCard />
          </ImpressionDivWrapper>
        </div>
        <div className={styles.cardItemWrapper}>
          <ImpressionDivWrapper
            className={styles.impressionWrapper}
            logData={{
              pageName: store.pageName,
              objectContainer: 'NOL에서 놀때는 NOL 카드',
              motherPageVersion: store.version,
              motherPageSectionType: '프로모션',
              motherPageSectionName: '공항 라운지 연 2회 무료',
            }}
          >
            <div ref={cardRef4}>
              <LoungeEventCard />
            </div>
          </ImpressionDivWrapper>
        </div>
      </div>
    </div>
  );
};

export default observer(NolCardBaseBenefits);
